+function ($) {

    $(document).ready(function(){
        processLevelChange();
    })

    $.each($(".smallimg"), function (i, item) {
        // $(item).click(mictab_content);
        $(item).hover(img_change);
        // $(item).mouseout(imgblur_change)
    })
    function img_change() {
        $(".bigimg").attr("src",$(this).attr("src"));
        $(this).parent().css("padding","0px")
        $(this).parent().css("border","2px solid #ee0000")
        $(this).parent().siblings().css("padding","auto")
        $(this).parent().siblings().css("border","0px solid #ee0000")
    }
    function imgblur_change() {
        $(this).css("padding","auto")
        $(this).css("border","0px solid #ee0000")
    }


    var $addCart = $("#addCart,#buy");
    var $quantity = $("#quantity");

    // 加入购物车
    $addCart.click(function(e) {
        var goodsid = $(".detail-content").attr('id');
        var goodsshape = $(".detail-table").attr('id');
        var diameter=$("#diameter").val();
        var processLevel=$("#processLevel").val();
        var proWidth=$("#proWidth").val();
        var proLength=$("#proLength").val();
        var thick= $("#thickness_input").val();
        var creditvalue = $("#creditvalue").val()
        if($("#thickness_input").is(":hidden")){
            thick=$("#thickness_select").val();
        }
        if(goodsshape=='SQUARE') {
            if (isEmpty(processLevel) || isEmpty(thick) || isEmpty(proWidth) || isEmpty(proLength)) {
                $.message("warn", "请选择商品规格");
                return false;
            }
            if(!/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/.test(thick) || !/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/.test(proWidth) || !/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/.test(proLength)){
                $.message("warn", "商品规格为数字");
                return false;
            }
        }
        if(goodsshape=='CYLINDER'){
            if(isEmpty(proLength) || diameter==0){
                $.message("warn", "请选择商品规格");
                return false;
                }
            if(!/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/.test(proLength)){
                $.message("warn", "商品规格为数字");
                return false;
            }
        }


        var tolerance= $("#tolerance").val();
        var quantity = $quantity.val();
        var processLevel = $("#processLevel").val();
        var thick= $("#thickness_input").val();
        var modelNum =$("#modelNum").val();
        var chamfer =$("#chamfer option:selected").val();
        if($("#thickness_input").is(":hidden")){
            thick=$("#thickness_select").val();
        }
        var proLength= $("#proLength").val();
        var proWidth = $("#proWidth").val();
        var posi_nega = $("#POSI_NEGA").val();
        var posi_negavalue = $("#POSI_NEGAVALUE").val();
        var processway = $("#processway").val();
        var diameter = $("#diameter").val();
        if (/^\d*[1-9]\d*$/.test(quantity)) {
            var data= {
                "commodityId": goodsid,
                "processType": processLevel,
                "chamfer": chamfer,
                "modelShape": goodsshape,
                "toleranceType": posi_nega,
                "tolerance": posi_negavalue,
                "additionalProcessing": processway,
                "credit": creditvalue,
                "specifications": [
                    {
                        "quantity": quantity,
                        "sides": [
                            {
                                "sideType": "LENGTH",
                                "value": proLength
                            },
                            {
                                "sideType": "THICKNESS",
                                "value": thick
                            },
                            {
                                "sideType": "WIDTH",
                                "value": proWidth
                            }
                        ]
                    }
                ]
            };
            if (goodsshape == "CYLINDER") {
                var data = {
                    "commodityId": goodsid,
                    "processType": "SEMI",
                    "chamfer": "true",
                    "modelShape": goodsshape,
                    "toleranceType": "POSI_NEGA",
                    "tolerance": 0,
                    "additionalProcessing": processway,
                    "credit": creditvalue,
                    "specifications": [
                        {
                            "quantity": quantity,
                            "sides": [
                                {
                                    "sideType": "LENGTH",
                                    "value": proLength
                                },
                                {
                                    "sideType": "DIAMETER",
                                    "value": diameter
                                }
                            ]
                        }
                    ]
                };
            }
            var is_send = true;
            if(goodsshape=='SQUARE'){
                if(processLevel != 'SEMI') {
                    heigthValidate();
                    if(!is_temp){
                        is_send = false;
                    }
                }
                widthValidate();
                if (!is_temp) {
                    is_send = false;
                }
            }
            lengthValidate();
            if(!is_temp){
                is_send = false;
            }
            if(is_send) {
                $.ajax({
                    url: "/api/cartCommodities",
                    type: "post",
                    contentType: "application/json",
                    data: JSON.stringify(data),
                    dataType: "json",
                    cache: false,

                    success: function (message) {
                        if (e.currentTarget.id == "addCart") {
                            $.message("success", "加入购物车成功！");
                            $(".j-cart-num").html(parseInt($(".j-cart-num").html()) + 1);
                        }
                        if (e.currentTarget.id == "buy") {
                            location.href = "/mall/orders?confirm&credit=" + creditvalue + "&cartids=" + message.id;
                        }
                    },
                    error: function (res) {
                        if (res.status == 401) {
                            location.href = "/mall/commodities/login-first/" + goodsid;
                        }
                    }
                });
            }
        } else {
            $.message("warn", "购买数量必须为正整数");
        }
    });




    fillselection();

    function processLevelChange(){
        var $this = $("#processLevel");
        $('.semi-disable').show();
        if ($this.val() == "0") {
            $("#proWidth").attr("readonly", true);
            $("#thickness_input").attr("readonly", true);
            $("#proLength").attr("readonly", true);
            $("#proWidth").attr('placeholder', '');
            $("#thickness_input").attr('placeholder', '');
            $("#proLength").attr('placeholder', '');
        } else {
            $("#proWidth").attr("readonly", false);
            $("#thickness_input").attr("readonly", false);
            $("#proLength").attr("readonly", false);
        }
        if ($this.val() == "CONCENTRATE") {
            $("#deviation").val("0.1");
            var thicknessValue = $("#CONCENTRATE").children("#THICKNESS").val();
            if (thicknessValue.split(",")[0] == 'RANGE') {
                $("#thickness_select").hide();
                $("#thickness_input").show();
                $("#thickness_input").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            } else {
                $("#thickness_select").empty()
                $("#thickness_input").hide();
                $("#thickness_select").show();
                var thicknessArrayValue = $("#CONCENTRATE").children("#THICKNESS").val().split(",").splice(1);
                $.each(thicknessArrayValue, function (i, n) {
                    $("#thickness_select").append("<option value=" + n + ">" + n + "</option>");
                });
            }
        } else if ($this.val() == "SEMI") {
            $('.semi-disable').hide();
            var thicknessValue = $("#SEMI").children("#THICKNESS").val();
            if (thicknessValue.split(",")[0] == 'RANGE') {
                $("#thickness_select").hide();
                $("#thickness_input").show();
                $("#thickness_input").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            } else {
                $("#thickness_select").empty()
                $("#thickness_input").hide();
                $("#thickness_select").show();
                var thicknessArrayValue = $("#SEMI").children("#THICKNESS").val().split(",").splice(1);
                $.each(thicknessArrayValue, function (i, n) {
                    $("#thickness_select").append("<option value=" + n + ">" + n + "</option>");
                });
            }
        } else if ($this.val() == "ROUGH") {
            $("#deviation").val("0.5");
            var thicknessValue = $("#ROUGH").children("#THICKNESS").val();
            if (thicknessValue.split(",")[0] == 'RANGE') {
                $("#thickness_select").hide();
                $("#thickness_input").show();
                $("#thickness_input").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            } else {
                $("#thickness_select").empty()
                $("#thickness_input").hide();
                $("#thickness_select").show();
                var thicknessArrayValue = $("#ROUGH").children("#THICKNESS").val().split(",").splice(1);
                $.each(thicknessArrayValue, function (i, n) {
                    $("#thickness_select").append("<option value=" + n + ">" + n + "</option>");
                });
            }
        }
        var is_width = true;
        var is_length = true;
        if ($this.val() == "ROUGH" && is_width) {
            var thicknessValue = $("#ROUGH").children("#WIDTH").val();
            $("#proWidth").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            is_width = false;
        }
        if ($this.val() == "SEMI" && is_width) {
            var thicknessValue = $("#SEMI").children("#WIDTH").val();
            $("#proWidth").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            is_width = false;
        }
        if ($this.val() == "CONCENTRATE" && is_width) {
            var thicknessValue = $("#CONCENTRATE").children("#WIDTH").val();
            $("#proWidth").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            is_width = false;
        }

        if ($this.val() == "ROUGH" && is_length) {
            var thicknessValue = $("#ROUGH").children("#LENGTH").val();
            $("#proLength").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            is_length = false;
        }
        if ($this.val() == "SEMI" && is_length) {
            var thicknessValue = $("#SEMI").children("#LENGTH").val();
            $("#proLength").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            is_length = false;
        }
        if ($this.val() == "CONCENTRATE" && is_length) {
            var thicknessValue = $("#CONCENTRATE").children("#LENGTH").val();
            $("#proLength").attr('placeholder', "范围" + thicknessValue.split(",")[1] + "到" + thicknessValue.split(",")[2]);
            is_length = false;
        }
        getNonStandardPrice();
    }

    $("#processLevel").change(function () {
        processLevelChange()
    });


    $("#thickness_select").change(function(){
        getNonStandardPrice();
    })

    $("#quantity").blur(function () {
        var quantity = parseFloat($("#quantity").val());
        if (!/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/.test(quantity)) {
            //$("#proWidth").focus();
            // padding_error(true,"proWidth","请输入数字，可以保留两位小数");
            $(this).val('');
            $(this).attr('placeholder', '请输入数字');
        }
    })
    function errrorTemplate (errorMessage) {
        return "<div id='error-prompt' style='position: absolute; background: #ff1e1e; top: -26px; color: white; width: max-content; padding: 2px 8px; border-radius: 2px'>" + errorMessage + "<div style='border: 7px solid transparent; width: 0; border-top-color: red; position: absolute;'></div></div>"
    }

    function widthValidate(){//宽度
            is_temp = false;
            var processLevel = $("#processLevel").val();
            var length = parseFloat($("#proLength").val());
            var width = parseFloat($("#proWidth").val());
            var thick;
            if(processLevel == 'SEMI'){
                thick = parseFloat($("#thickness_select").val());
            }else{
                thick = parseFloat($("#thickness_input").val());
            }
            if (processLevel == 0) {
                //$("#processLevel").focus();
                // padding_error(true,"processLevel","请先选择加工类型");
                // $(this).val('');
                // $(this).attr('placeholder', '请先选择加工类型');
                $('#processLevel').before(errrorTemplate('请先选择加工类型'));
            } else if (!/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/.test(width)) {
                //$("#proWidth").focus();
                // padding_error(true,"proWidth","请输入数字，可以保留两位小数");
                // $(this).val('');
                // $(this).attr('placeholder', '请输入数字，可以保留两位小数');
                $("#proWidth").before(errrorTemplate('请输入数字，可以保留两位小数'));
            } else if (processLevel == 'CONCENTRATE' && (width < $("#CONCENTRATE").children("#WIDTH").val().split(",")[1] || width > $("#CONCENTRATE").children("#WIDTH").val().split(",")[2])) {
                //$("#proWidth").focus();
                // $(this).val("");
                // $(this).attr('placeholder', "请输入范围" + $("#CONCENTRATE").children("#WIDTH").val().split(",")[1] + "到" + $("#CONCENTRATE").children("#WIDTH").val().split(",")[2] + "的值");
                $("#proWidth").before(errrorTemplate("请输入范围" + $("#CONCENTRATE").children("#WIDTH").val().split(",")[1] + "到" + $("#CONCENTRATE").children("#WIDTH").val().split(",")[2] + "的值"));
            } else if (processLevel == "SEMI" && (width < $("#SEMI").children("#WIDTH").val().split(",")[1] || width > $("#SEMI").children("#WIDTH").val().split(",")[2])) {
                //$("#proWidth").focus();
                // $(this).val("");
                // $(this).attr('placeholder', "请输入范围" + $("#SEMI").children("#WIDTH").val().split(",")[1] + "到" + $("#SEMI").children("#WIDTH").val().split(",")[2] + "的值");
                $("#proWidth").before(errrorTemplate("请输入范围" + $("#SEMI").children("#WIDTH").val().split(",")[1] + "到" + $("#SEMI").children("#WIDTH").val().split(",")[2] + "的值"));
            } else if (processLevel == "ROUGH" && (width < $("#ROUGH").children("#WIDTH").val().split(",")[1] || width > $("#ROUGH").children("#WIDTH").val().split(",")[2])) {
                //$("#proWidth").focus();
                // $(this).val("");
                // $(this).attr('placeholder', "请输入范围" + $("#ROUGH").children("#WIDTH").val().split(",")[1] + "到" + $("#ROUGH").children("#WIDTH").val().split(",")[2] + "的值");
                $("#proWidth").before(errrorTemplate("请输入范围" + $("#ROUGH").children("#WIDTH").val().split(",")[1] + "到" + $("#ROUGH").children("#WIDTH").val().split(",")[2] + "的值"));
            } else if (!isEmpty(length) && parseInt(width) > parseInt(length)) {
                //$("#proLength").focus();
                // $(this).val("");
                // $(this).attr('placeholder', '宽度不能大于长度');
                $("#proWidth").before(errrorTemplate('宽度不能大于长度'));
                //clearFlat();
            } else if (!isEmpty(width) && parseInt(thick) > parseInt(width)) {
                // $(this).val("");
                // $(this).attr('placeholder', '厚度不能大于宽度');
                $("#proWidth").before(errrorTemplate('厚度不能大于宽度'));
            } else {
                // padding_error(false,"proWidth","");
                // padding_error(false,"processLevel","");
                //都不能为空
                if (!isEmpty(processLevel) && !isEmpty(thick) && !isEmpty(width) && !isEmpty(length)) {
                    getNonStandardPrice();
                }
            }
            setTimeout(function () {
                $('#error-prompt').fadeOut()
                $('#error-prompt').remove()
            }, 3000)
    }

    $("#proWidth").blur(function () {
        widthValidate();
    });

    function heigthValidate() {//厚度
        is_temp = false;
        var length = parseFloat($("#proLength").val());
        var width = parseFloat($("#proWidth").val());
        var processLevel = $("#processLevel").val();
        var thick;
        if(processLevel == 'SEMI'){
            thick = parseFloat($("#thickness_select").val());
        }else{
            thick = parseFloat($("#thickness_input").val());
        }

        if (processLevel == 0) {
            //$("#processLevel").focus();
            // padding_error(true,"processLevel","请先选择加工类型");
            // $(this).val('');
            // $(this).attr('placeholder', '请先选择加工类型');
            $('#processLevel').before(errrorTemplate('请先选择加工类型'));
        } else if (!/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/.test(thick)) {
            //$("#proWidth").focus();
            // padding_error(true,"proWidth","请输入数字，可以保留两位小数");
            // $(this).val('');
            $("#thickness_input").before(errrorTemplate('请输入数字，可以保留两位小数'));
            // $(this).attr('placeholder', '请输入数字，可以保留两位小数');
        } else if (processLevel == 'CONCENTRATE' && (thick < $("#CONCENTRATE").children("#THICKNESS").val().split(",")[1] || thick > $("#CONCENTRATE").children("#THICKNESS").val().split(",")[2])) {
            //$("#proWidth").focus();
            // $(this).val("");
            $("#thickness_input").before(errrorTemplate("请输入范围" + $("#CONCENTRATE").children("#THICKNESS").val().split(",")[1] + "到" + $("#CONCENTRATE").children("#THICKNESS").val().split(",")[2] + "的值"));
            // $(this).attr('placeholder', "请输入范围" + $("#CONCENTRATE").children("#THICKNESS").val().split(",")[1] + "到" + $("#CONCENTRATE").children("#THICKNESS").val().split(",")[2] + "的值");
        } else if (processLevel == "SEMI" && (thick < $("#SEMI").children("#THICKNESS").val().split(",")[1] || thick > $("#SEMI").children("#THICKNESS").val().split(",")[2])) {
            //$("#proWidth").focus();
            // $(this).val("");
            // $(this).attr('placeholder', "请输入范围" + $("#SEMI").children("#THICKNESS").val().split(",")[1] + "到" + $("#SEMI").children("#THICKNESS").val().split(",")[2] + "的值");
            $("#thickness_input").before(errrorTemplate("请输入范围" + $("#SEMI").children("#THICKNESS").val().split(",")[1] + "到" + $("#SEMI").children("#THICKNESS").val().split(",")[2] + "的值"));
        } else if (processLevel == "ROUGH" && (thick < $("#ROUGH").children("#THICKNESS").val().split(",")[1] || thick > $("#ROUGH").children("#THICKNESS").val().split(",")[2])) {
            //$("#proWidth").focus();
            // $(this).val("");
            // $(this).attr('placeholder', "请输入范围" + $("#ROUGH").children("#THICKNESS").val().split(",")[1] + "到" + $("#ROUGH").children("#THICKNESS").val().split(",")[2] + "的值");
            $("#thickness_input").before(errrorTemplate("请输入范围" + $("#ROUGH").children("#THICKNESS").val().split(",")[1] + "到" + $("#ROUGH").children("#THICKNESS").val().split(",")[2] + "的值"));
        } else if (!isEmpty(width) && parseInt(thick) > parseInt(width)) {
            // $(this).val("");
            // $(this).attr('placeholder', '厚度不能大于宽度');
            $("#thickness_input").before(errrorTemplate("厚度不能大于宽度"));
        } else {
            // padding_error(false,"proWidth","");
            // padding_error(false,"processLevel","");
            //都不能为空
            if (!isEmpty(processLevel) && !isEmpty(thick) && !isEmpty(width) && !isEmpty(length)) {
                getNonStandardPrice();
            }
        }
        setTimeout(function () {
            $('#error-prompt').fadeOut()
            $('#error-prompt').remove()
        }, 3000)
    }

    $("#thickness_input").blur(function () {
        heigthValidate()
    });

    function lengthValidate() {//长度
        is_temp = false;
        var length = parseFloat($("#proLength").val());
        var width = parseFloat($("#proWidth").val());
        var processLevel = $("#processLevel").val();
        var thick;
        if(processLevel == 'SEMI'){
            thick = parseFloat($("#thickness_select").val());
        }else{
            thick = parseFloat($("#thickness_input").val());
        }

        if (processLevel == 0) {
            //$("#processLevel").focus();
            // padding_error(true,"processLevel","请先选择加工类型");
            // $(this).val('');
            // $(this).attr('placeholder', '请先选择加工类型');
            $('#processLevel').before(errrorTemplate('请先选择加工类型'));
        } else if (!/^(([0-9]+)|([0-9]+\.[0-9]{1,2}))$/.test(length)) {
            //$("#proWidth").focus();
            // padding_error(true,"proWidth","请输入数字，可以保留两位小数");
            // $(this).val('');
            // $(this).attr('placeholder', '请输入数字，可以保留两位小数');
            $("#proLength").before(errrorTemplate("请输入数字，可以保留两位小数"));
        } else if (processLevel == 'CONCENTRATE' && (length < $("#CONCENTRATE").children("#LENGTH").val().split(",")[1] || length > $("#CONCENTRATE").children("#LENGTH").val().split(",")[2])) {
            //$("#proWidth").focus();
            $("#proLength").val("");
            // $(this).attr('placeholder', "请输入范围" + $("#CONCENTRATE").children("#LENGTH").val().split(",")[1] + "到" + $("#CONCENTRATE").children("#LENGTH").val().split(",")[2] + "的值");
            $("#proLength").before(errrorTemplate("请输入范围" + $("#CONCENTRATE").children("#LENGTH").val().split(",")[1] + "到" + $("#CONCENTRATE").children("#LENGTH").val().split(",")[2] + "的值"));
        } else if ((processLevel == "SEMI" || isEmpty(processLevel)) && (length < $("#SEMI").children("#LENGTH").val().split(",")[1] || length > $("#SEMI").children("#LENGTH").val().split(",")[2])) {
            //$("#proWidth").focus();
            // $(this).val("");
            // $(this).attr('placeholder', "请输入范围" + $("#SEMI").children("#LENGTH").val().split(",")[1] + "到" + $("#SEMI").children("#LENGTH").val().split(",")[2] + "的值");
            $("#proLength").before(errrorTemplate("请输入范围" + $("#SEMI").children("#LENGTH").val().split(",")[1] + "到" + $("#SEMI").children("#LENGTH").val().split(",")[2] + "的值"));
        } else if (processLevel == "ROUGH" && (length < $("#ROUGH").children("#LENGTH").val().split(",")[1] || length > $("#ROUGH").children("#LENGTH").val().split(",")[2])) {
            //$("#proWidth").focus();
            // $(this).val("");
            // $(this).attr('placeholder', "请输入范围" + $("#ROUGH").children("#LENGTH").val().split(",")[1] + "到" + $("#ROUGH").children("#LENGTH").val().split(",")[2] + "的值");
            $("#proLength").before(errrorTemplate("请输入范围" + $("#ROUGH").children("#LENGTH").val().split(",")[1] + "到" + $("#ROUGH").children("#LENGTH").val().split(",")[2] + "的值"));
        } else if (!isEmpty(length) && parseInt(width) > parseInt(length)) {
            //$("#proLength").focus();
            // $(this).val("");
            // $(this).attr('placeholder', '宽度不能大于长度');
            $("#proLength").before(errrorTemplate('宽度不能大于长度'));
            //clearFlat();
        } else {
            // padding_error(false,"proWidth","");
            // padding_error(false,"processLevel","");
            //都不能为空
            if (!isEmpty(processLevel) && !isEmpty(thick) && !isEmpty(width) && !isEmpty(length) || (!isEmpty(length) && !isEmpty(diameter))) {
                getNonStandardPrice();
            }
        }
        setTimeout(function () {
            $('#error-prompt').fadeOut()
            $('#error-prompt').remove()
        }, 3000)
    }

    $("#proLength").blur(function () {
        lengthValidate()
    });

}(jQuery)



// 货币格式化
function currency(value, showSign, showUnit) {
    if (value != null) {
        var price = (Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)).toFixed(2);
        if (showSign) {
            price = '￥' + price;
        }
        if (showUnit) {
            price += '元';
        }
        return price;
    }
}

function isEmpty(value) {
    if (value == null || value == "" || value == "undefined" || value == undefined || value == "null") {
        return true;
    } else {
        /*value = value.toString().replace(/\s/g,"");
        if(value == ""){
            return true;
        }*/
        return false;
    }
}

//显示商品的计算价格
function getNonStandardPrice() {
    var width = $("#proWidth").val();
    var length = $("#proLength").val();
    var thick = $("#thickness_input").val();
    if (isEmpty(thick)) {
        thick = $("#thickness_select").val();
        if (!isEmpty(width) && parseInt(thick) > parseInt(width)) {
            // $("#proWidth").val("");
            // $("#proWidth").attr('placeholder', '厚度不能大于宽度');
            $("#proWidth").before(errrorTemplate('厚度不能大于宽度'));
            setTimeout(function () {
                $('#error-prompt').fadeOut()
                $('#error-prompt').remove()
            }, 3000)
            return;
        }
    }

    var quantity = $("#quantity").val();
    var processLevel = $("#processLevel").val();
    var diameter = $("#diameter").val();
    var processway = $("#processway").val();

    var creditvalue = $("#creditvalue").val()
    if (!isEmpty(diameter)) {
        if (diameter <= 100) {
            $("#tolerance").val("(0/+3)mm");
        } else if (diameter > 100 && diameter <= 300) {
            $("#tolerance").val("(0/+5)mm");
        } else {
            $("#tolerance").val("(0/+10)mm");
        }
    }

    var goodsid = $(".detail-content").attr('id');
    var goodsshape = $(".detail-table").attr('id');

    var data = {
        "commodityId": goodsid,
        "credit": creditvalue,
        "modelShape": goodsshape,
        "processType": processLevel,
        "additionalProcessing": processway,
        "specifications": [
            {
                "id": null,
                "quantity": quantity,
                "weight": null,
                "processingCharges": null,
                "materialCharges": null,
                "sides": [
                    {
                        "id": null,
                        "sideType": "LENGTH",
                        "value": length
                    },
                    {
                        "id": null,
                        "sideType": "THICKNESS",
                        "value": thick
                    },
                    {
                        "id": null,
                        "sideType": "WIDTH",
                        "value": width
                    }
                ],
                "commodity": null
            }
        ]
    };

    if (goodsshape == "CYLINDER") {
        var data = {
            "commodityId": goodsid,
            "credit": creditvalue,
            "modelShape": goodsshape,
            "processType": "SEMI",
            "additionalProcessing": processway,
            "specifications": [
                {
                    "id": null,
                    "quantity": quantity,
                    "weight": null,
                    "processingCharges": null,
                    "materialCharges": null,
                    "sides": [
                        {
                            "id": null,
                            "sideType": "LENGTH",
                            "value": length
                        },
                        {
                            "id": null,
                            "sideType": "DIAMETER",
                            "value": diameter
                        }
                    ],
                    "commodity": null
                }
            ]
        };
    }

    if ((!isEmpty(processLevel) && !isEmpty(width) && !isEmpty(length) && !isEmpty(thick) && !isEmpty(quantity)) || (!isEmpty(length) && !isEmpty(diameter))) {
        $.ajax({
            url: "/api/price",
            type: "post",
            async: false,
            contentType: "application/json",
            data: JSON.stringify(data),
            dataTyoe: "json",
            cache: false,
            success: function (data) {
                if (!isEmpty(data)) {
                    if (data.processPrice == 0)
                        $("#processPrice").html(0 + " 元");
                    else
                        $("#processPrice").html(data.specifications[0].processingCharges + "	元");
                    // $("#unitPrice").html(currency(data.price, true) + " /kg");
                    // $("#marketPrice").html(currency(data.unitPrice*1.2, true)	+"元/kg");
                    $("#unitWeight").html(data.specifications[0].weight + " kg");
                    if(data.credit)
                        $("#singlePrice").html(currency((data.specifications[0].processingCharges + data.specifications[0].interest) * data.specifications[0].quantity, true) + " ");
                    else
                        $("#singlePrice").html(currency((data.specifications[0].processingCharges + data.specifications[0].materialCharges) * data.specifications[0].quantity, true) + " ");
                    is_temp = true;
                    // $(".text-36").html(data.price.toFixed(2));
                }
            }
        });
    }
    return true;
}

function fillselection() {
    if (!isEmpty($("#SEMI").children("#DIAMETER").val())) {
        var lengthValue = $("#SEMI").children("#LENGTH").val();
        $("#proLength").attr('placeholder', "范围" + lengthValue.split(",")[1] + "到" + lengthValue.split(",")[2]);
        var thicknessArrayValue = $("#SEMI").children("#DIAMETER").val().split(",").splice(1);
        $.each(thicknessArrayValue, function (i, n) {
            $("#diameter").append("<option value=" + n + ">" + n + "</option>");
        });
    }
}

// 消息框
var $message;
var messageTimer;
$.message = function() {
    var message = {};
    if ($.isPlainObject(arguments[0])) {
        message = arguments[0];
    } else if (typeof arguments[0] === "string" && typeof arguments[1] === "string") {
        message.type = arguments[0];
        message.content = arguments[1];
    } else {
        return false;
    }

    if (message.type == null || message.content == null) {
        return false;
    }

    if ($message == null) {
        var messageString = message.type != 'success' ? '<div class="xxMessage" ><i class="iconfont icon-warning" style="float:left;"></i><div class="messageContent message' + escapeHtml(message.type) + 'Icon" STYLE="width : 120px;"><\/div><\/div>' : '<div class="xxMessage" ><div class="messageContent message' + escapeHtml(message.type) + 'Icon" STYLE="width : 120px;"><\/div><\/div>'
        $message = $(messageString);
        if (!window.XMLHttpRequest) {
            $message.append('<iframe class="messageIframe"><\/iframe>');
        }
        $message.appendTo("body");
    }

    $message.children("div").removeClass("messagewarnIcon messageerrorIcon messagesuccessIcon").addClass("message" + message.type + "Icon").html(message.content);
    $message.css({"margin-left": - parseInt($message.outerWidth() / 2), "z-index": 9999}).show();

    clearTimeout(messageTimer);
    messageTimer = setTimeout(function() {
        $message.hide();
    }, 3000);
    return $message;
}


function escapeHtml(str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
